import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { IntegrationItemModalComponent } from './integration-item-modal.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        IntegrationItemModalComponent
    ],
    exports: [
        IntegrationItemModalComponent
    ]
})
export class IntegrationItemSharedModule { }
